import React from "react";
import classes from "./MeetingCatalog.module.css"
import Catalog from "../../../../img/Catalog.png"

const MeetingCatalog = () => {
    return (
        <div className={classes.MeetingCatalog}>
            <div className={classes.contentTextCatalogMeet}>
                <img src={Catalog} alt="Каталог" />
                <h1>Каталог</h1>
            </div>
        </div>
    )
}

export default MeetingCatalog